var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Task component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTask extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.65919 2.60498C9.2114 2.60498 8.84839 2.96799 8.84839 3.41578V4.19618C8.84839 4.64397 9.2114 5.00698 9.65919 5.00698H14.3416C14.7894 5.00698 15.1524 4.64397 15.1524 4.19618V3.42814L15.1523 3.41553L15.1523 3.40655C15.1474 2.96301 14.7863 2.60498 14.3416 2.60498H9.65919ZM16.6524 4.19618V4.16553H18.2435C18.4585 4.16553 18.6647 4.25095 18.8168 4.403C18.9689 4.55506 19.0543 4.76129 19.0543 4.97633V20.5843C19.0543 20.7993 18.9689 21.0056 18.8168 21.1576C18.6647 21.3097 18.4585 21.3951 18.2435 21.3951H5.75709C5.54205 21.3951 5.33582 21.3097 5.18377 21.1576C5.03171 21.0056 4.94629 20.7993 4.94629 20.5843V4.97633C4.94629 4.76129 5.03171 4.55506 5.18377 4.403C5.33582 4.25095 5.54205 4.16553 5.75709 4.16553H7.34839V4.19618C7.34839 5.4724 8.38297 6.50698 9.65919 6.50698H14.3416C15.6178 6.50698 16.6524 5.4724 16.6524 4.19618ZM9.65919 1.10498C8.64559 1.10498 7.78441 1.75758 7.47291 2.66553H5.75709C5.14423 2.66553 4.55646 2.90899 4.12311 3.34234C3.68975 3.7757 3.44629 4.36346 3.44629 4.97633V20.5843C3.44629 21.1972 3.68975 21.7849 4.12311 22.2183C4.55646 22.6517 5.14423 22.8951 5.75709 22.8951H18.2435C18.8563 22.8951 19.4441 22.6517 19.8775 22.2183C20.3108 21.7849 20.5543 21.1972 20.5543 20.5843V4.97633C20.5543 4.36346 20.3108 3.7757 19.8775 3.34234C19.4441 2.90899 18.8563 2.66553 18.2435 2.66553H16.5279C16.2164 1.75758 15.3552 1.10498 14.3416 1.10498H9.65919ZM8.09839 8.90869C7.68418 8.90869 7.34839 9.24448 7.34839 9.65869C7.34839 10.0729 7.68418 10.4087 8.09839 10.4087H15.9024C16.3166 10.4087 16.6524 10.0729 16.6524 9.65869C16.6524 9.24448 16.3166 8.90869 15.9024 8.90869H8.09839ZM7.34839 13.561C7.34839 13.1468 7.68418 12.811 8.09839 12.811H15.9024C16.3166 12.811 16.6524 13.1468 16.6524 13.561C16.6524 13.9752 16.3166 14.311 15.9024 14.311H8.09839C7.68418 14.311 7.34839 13.9752 7.34839 13.561ZM8.09839 16.7134C7.68418 16.7134 7.34839 17.0492 7.34839 17.4634C7.34839 17.8776 7.68418 18.2134 8.09839 18.2134H15.9024C16.3166 18.2134 16.6524 17.8776 16.6524 17.4634C16.6524 17.0492 16.3166 16.7134 15.9024 16.7134H8.09839Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTask.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTask.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTask.prototype, "size", void 0);
if (customElements.get('cat-icon-task') === undefined) {
    customElements.define('cat-icon-task', BlocksIconTask);
}
